var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.529,
    height: 23.529,
    viewBox: "0 0 23.529 23.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22",
    "data-name": "Layer 22",
    transform: "translate(-2.001 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M17.966,10.79,14.95,13.765l3.017,2.975a.853.853,0,1,1-1.185,1.227l-3.017-3.017L10.79,17.966a.838.838,0,0,1-1.185-1.185l2.975-3.017L9.605,10.79A.84.84,0,0,1,10.79,9.6l2.975,2.975L16.74,9.6a.853.853,0,0,1,1.227,1.185Zm4.118,11.294a11.765,11.765,0,1,1,0-16.639,11.765,11.765,0,0,1,0,16.639ZM20.9,6.63a10.084,10.084,0,1,0,2.966,7.143A10.084,10.084,0,0,0,20.9,6.63Z",
    transform: "translate(0 0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cdf42d18c7df7454b1a8bcae86df8db3.svg";
export { ForwardRef as ReactComponent };